
export default {
  home: '/',
  settings: '/settings',
  allStats: '/stats',
  history: '/history',
  login: '/login',
  logout: '/logout',
  register: '/register',
  activateSpotify: '/activate',
};
